<template>
  <div class="view_component">
    <div>
      <img
        class="view_component-logo"
        :src="require('@/assets/Logo_secondary_for_yellow_bg.svg')"
        alt="Yellowcard Logo"
      />
    </div>
    <div>
      <LoginModal />
    </div>
  </div>
</template>

<script lang="ts">
import { onBeforeMount } from 'vue';
import { storeToRefs } from 'pinia';
import { useAuthStore } from '@/store/modules/auth';
import LoginModal from '@/components/auth/LoginModal.vue';
import { useVisitorData } from '@fingerprintjs/fingerprintjs-pro-vue-v3';

export default {
  name: 'LoginView',
  components: {
    LoginModal,
  },
  setup() {
    const authStore = useAuthStore();
    const { deviceId } = storeToRefs(authStore);
    authStore.setCurrentStep(1);
    authStore.setTotalSteps(2);

    const { data, getData } = useVisitorData(
      { extendedResult: true },
      { immediate: false },
    );
    const getDeviceID = async () => {
      await getData();
      deviceId.value = data.value?.visitorId;
    };

    onBeforeMount(async () => {
      await getDeviceID();
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/common/styles/_base.scss';
</style>
